// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-premium {
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  box-shadow: 
    0 1px 3px rgba(0, 0, 0, 0.02),
    0 4px 12px rgba(0, 0, 0, 0.01);
  overflow: hidden;
  position: relative;
  transition: all 0.3s ease;
}

.card-premium:hover {
  box-shadow: 
    0 4px 6px rgba(0, 0, 0, 0.04),
    0 10px 20px rgba(0, 0, 0, 0.02);
}

.card-header-spark {
  padding: 20px 20px 0px;
}

.spark-icon-wrapper {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.spark-title {
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 2px 0;
}

.spark-subtitle {
  font-size: 10px;
  color: #94a3b8;
  margin: 0;
}

.card-value-spark h2 {
  font-size: 38px;
  font-weight: 800;
  color: #0f172a;
  margin: 0;
  font-family: "Outfit", "Inter", sans-serif;
  letter-spacing: -0.5px;
}

.sparkline-chart-wrapper {
  margin-bottom: -5px;
  margin-left: -5px;
  margin-right: -5px;
  width: calc(100% + 10px);
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboard/MetricTrendCard.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB;;kCAEgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE;;mCAEiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;AAC1B","sourcesContent":[".card-premium {\n  background-color: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 20px;\n  box-shadow: \n    0 1px 3px rgba(0, 0, 0, 0.02),\n    0 4px 12px rgba(0, 0, 0, 0.01);\n  overflow: hidden;\n  position: relative;\n  transition: all 0.3s ease;\n}\n\n.card-premium:hover {\n  box-shadow: \n    0 4px 6px rgba(0, 0, 0, 0.04),\n    0 10px 20px rgba(0, 0, 0, 0.02);\n}\n\n.card-header-spark {\n  padding: 20px 20px 0px;\n}\n\n.spark-icon-wrapper {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.spark-title {\n  font-size: 13px;\n  font-weight: 700;\n  color: #1e293b;\n  margin: 0 0 2px 0;\n}\n\n.spark-subtitle {\n  font-size: 10px;\n  color: #94a3b8;\n  margin: 0;\n}\n\n.card-value-spark h2 {\n  font-size: 38px;\n  font-weight: 800;\n  color: #0f172a;\n  margin: 0;\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n  letter-spacing: -0.5px;\n}\n\n.sparkline-chart-wrapper {\n  margin-bottom: -5px;\n  margin-left: -5px;\n  margin-right: -5px;\n  width: calc(100% + 10px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
